/*
 * @Author: your name
 * @Date: 2021-03-10 13:16:52
 * @LastEditTime: 2021-03-16 21:42:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_web\src\router\routes.js
 */
export const routes = [
  //首页
  {
    path: '/main',
    name: 'Main',
    // 路由懒加载
    component: r => (require(['@/views/Main.vue'], r)),
    children: [
      {
        path: '/home',
        name: 'Home',
        // 路由懒加载
        component: r => (require(['@/views/Home.vue'], r))
      },
      {
        path: '/product',
        name: 'Product',
        // 路由懒加载
        component: r => (require(['@/views/Product.vue'], r))
      },
      {
        path: '/starItem',
        name: 'StarItem',
        // 路由懒加载
        component: r => (require(['@/views/StarItem.vue'], r))
      },
      {
        path: '/patent',
        name: 'AOG',
        // 路由懒加载
        component: r => (require(['@/views/AOG.vue'], r))
      },
      {
        path: '/brandNews',
        name: 'BrandNews',
        // 路由懒加载
        component: r => (require(['@/views/BrandNews.vue'], r)),
      },
      {
            path: '/detail',
            name: 'ArticleDetail',
            // 路由懒加载
            component: r => (require(['@/views/ArticleDetail.vue'], r))
          },
      {
        path: '/Introduce',
        name: 'Introduce',
        // 路由懒加载
        component: r => (require(['@/views/Introduce.vue'], r))
      },
      {
        path: '/aboutUs',
        name: 'AboutUs',
        // 路由懒加载
        component: r => (require(['@/views/AboutUs.vue'], r))
      },
    ]
  },
  {
    path: '*',
    redirect: {
      name: 'Home'
    }
  }
]
